<template>
    <v-main
      class="mainBackground"
    >
      <v-container
        fluid
      >

        <VictimNotification />
        
        <router-view></router-view>

      </v-container>
    </v-main>
</template>

<!-- <style>
@import url('https://fonts.googleapis.com/css2?family=Fredericka+the+Great&display=swap');
</style>-->
<style>
.mainBackground{
  background-image: url(https://i.imgur.com/xcIB3MT.gif);
  background-repeat: repeat;
}
</style>

<script>
import VictimNotification from '@/components/structure/body/victimNotify';

export default {
  name: 'Body',

  components: {
    VictimNotification,
  },
};
</script>
